const actions = {
  groupStatus ({ rootState }, params) {
    return rootState.axios.get('/magicbuy/dgorder/stats/group-status', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  }
}

export default {
  namespaced: true,
  actions
}
